import { createContentPropTypes } from '../../../helpers/content';

const content = {
	header: 'Payment and transfers',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
